import React, { useCallback } from 'react';
import MoreIcon from '@atlaskit/icon/glyph/more';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import Button from '@atlaskit/button';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';

export const MoreActionsMenu = ({
  isEstimatePDFDownloading,
  isEstimateJsonIsDownloading,
  onEstimationPDFClick,
  onEstimationJSONClick,
  onClearAllClick,
  hasSplitButtonActionMenu,
}: {
  isEstimatePDFDownloading: boolean;
  isEstimateJsonIsDownloading: boolean;
  onEstimationPDFClick: () => void;
  onEstimationJSONClick: () => void;
  onClearAllClick: () => void;
  hasSplitButtonActionMenu?: boolean;
}) => {
  const renderDropdownMenu = useCallback(() => {
    return (
      <DropdownItemGroup>
        <DropdownItem onClick={onEstimationPDFClick}>Estimate PDF</DropdownItem>
        <DropdownItem onClick={onEstimationJSONClick}>Estimate JSON</DropdownItem>
        <DropdownItem onClick={onClearAllClick}>Clear all</DropdownItem>
      </DropdownItemGroup>
    );
  }, [onEstimationPDFClick, onEstimationJSONClick, onClearAllClick]);

  return (
    <>
      {hasSplitButtonActionMenu ? (
        <DropdownMenu
          position="bottom right"
          isLoading={isEstimatePDFDownloading || isEstimateJsonIsDownloading}
          trigger={
            <Button
              appearance="primary"
              testId="spilt-more-actions-menu"
              iconBefore={<ChevronDownIcon label="More" size="medium" />}
            />
          }
        >
          {renderDropdownMenu()}
        </DropdownMenu>
      ) : (
        <DropdownMenu
          isLoading={isEstimatePDFDownloading || isEstimateJsonIsDownloading}
          position="bottom right"
          triggerType="button"
          triggerButtonProps={{
            appearance: 'subtle',
            role: 'menu',
            iconBefore: <MoreIcon label="More" />,
            className: 'trigger-button',
          }}
          testId="more-actions-menu"
        >
          {renderDropdownMenu()}
        </DropdownMenu>
      )}
    </>
  );
};
